import { AxiosResponse } from "axios";

import {
  IContactData,
  IOptInKey,
  IOptInPayload,
  IOptInSettings,
} from "../../../store/optIn/types";
import { LabelValue } from "../../../types/common";
import { apiPublicAxios } from "../../axios";
import { OPT_IN } from "../../resources";

export const validateOptInKey = (
  key: string
): Promise<AxiosResponse<IOptInKey>> => {
  return apiPublicAxios.get<IOptInKey>(`${OPT_IN}/validateOptInKey`, {
    headers: {
      "X-Api-Key": key,
    },
  });
};

export const getContactInformation = (
  key: string
): Promise<AxiosResponse<IContactData>> =>
  apiPublicAxios.get(`${OPT_IN}/getContactData`, {
    headers: {
      "X-Api-Key": key,
    },
  });

export const getContactMethods = (
  key: string
): Promise<AxiosResponse<LabelValue[]>> =>
  apiPublicAxios.get(`${OPT_IN}/preferredContactMethods`, {
    headers: {
      "X-Api-Key": key,
    },
  });

export const getOptInSettings = (
  key: string
): Promise<AxiosResponse<IOptInSettings>> =>
  apiPublicAxios.get(`${OPT_IN}/settings`, {
    headers: {
      "X-Api-Key": key,
    },
  });

export const saveOptInForm = ({
  payload,
  key,
}: {
  key: string;
  payload: IOptInPayload;
}): Promise<AxiosResponse<IOptInSettings>> =>
  apiPublicAxios.post(`${OPT_IN}/saveOptInForm`, payload, {
    params: { key },
  });
